import { Injectable, Pipe, PipeTransform, inject } from '@angular/core';
import { LanguageService, StoreService } from '@seu-services';
import {
  SeuConfigTranslationObject,
  SeuLanguage,
  isSeuConfigComponentTranslation,
} from '@seu-types';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'seuConfigSynonyms',
})
export class SeuConfigSynonymsPipe implements PipeTransform {
  private readonly store = inject(StoreService);
  private readonly languageService = inject(LanguageService);

  public transform(value: string): string[] {
    const lang: SeuLanguage = this.languageService.getLang();

    const keyArray = value.split('.');
    let returnValue: string | string[] | null = keyArray[keyArray.length - 1];
    // Fallback to DE if the current language key doesn't exist in translations
    const translations = this.store.getConfig()?.translations;
    let translationObject = translations?.[lang] ?? translations?.['DE'];

    keyArray.forEach((key: string) => {
      if (translationObject) {
        const translationValue = translationObject[key];
        if (translationValue !== undefined && translationValue !== null) {
          if (Array.isArray(translationValue)) {
            // Reached the final array value (e.g. synonyms / unit keywords)
            returnValue = translationValue as string[];
          } else if (isSeuConfigComponentTranslation(translationValue)) {
            // Typed component entry — treat as traversable translation object
            // so nested key access (e.g. '.synonyms') works on the next iteration
            translationObject =
              translationValue as unknown as SeuConfigTranslationObject;
          } else if (typeof translationValue === 'object') {
            translationObject = translationValue;
          } else if (typeof translationValue === 'string') {
            // Single-value synonym (e.g. synonyms: 'Modifier')
            returnValue = translationValue;
          }
        } else if (translationValue === '') {
          returnValue = '';
        }
      }
    });

    if (Array.isArray(returnValue)) {
      return returnValue;
    }

    return returnValue ? [returnValue] : [];
  }
}
